import Dropdown from "react-bootstrap/esm/Dropdown";
import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { useUmsUrl } from "../services/useTouUrl";

interface IActionDropdownUMSLinkProps {
    action: IPageAction
}

export const ActionDropdownUMSLink: FC<IActionDropdownUMSLinkProps> = ({
    action
}) => {
    const { umsUrl } = useUmsUrl()
    if (!umsUrl)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    return (
        <Dropdown.Item
            href={umsUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Dropdown.Item>
    )
}

